import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { Button, Form } from "react-bootstrap";
import { Switch, Table } from "antd";
import { BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import { alertMessage } from "../../utils/AlertService";
import { INVENTORY_CATEGORY_MASTER_COLUMN, INVENTORY_ITEM_MASTER_COLUMN, INVENTORY_OPENING_BALANCE_COLUMN, INVENTORY_TRANSACTIONS_COLUMN } from "../constant/AppConstant";
import { useDeleteInventoryCategoryMasterMutation, useGetAllInventoryCategoryMasterMutation, useSearchInventoryCategoryMasterMutation } from "../../redux-toolkit/services/inventoryCategoryMasterService";
import { getInventoryCategoryMasterDetails, getInventoryCategoryMasterSearch, getInventoryCategoryMasterTotalRecords, setInventoryCategoryMaster, setInventoryCategoryMasterBySearch } from "../../redux-toolkit/slices/inventoryCategoryMasterSlice";
import { useDeleteInventoryItemMasterMutation, useGetAllInventoryItemMasterMutation, useSearchInventoryItemMasterMutation } from "../../redux-toolkit/services/inventoryItemMasterService";
import { getInventoryItemMasterDetails, getInventoryItemMasterSearch, getInventoryItemMasterTotalRecords, setInventoryItemMaster, setInventoryItemMasterBySearch } from "../../redux-toolkit/slices/inventoryItemMasterSlice";
import { useDeleteInventoryOpeningBalanceMutation, useGetAllInventoryOpeningBalanceMutation, useSearchInventoryOpeningBalanceMutation } from "../../redux-toolkit/services/inventoryOpeningBalanceService";
import { getInventoryOpeningBalanceDetails, getInventoryOpeningBalanceSearch, getInventoryOpeningBalanceTotalRecords, setInventoryOpeningBalance, setInventoryOpeningBalanceBySearch } from "../../redux-toolkit/slices/inventoryOpeningBalanceSlice";
import { useDeleteInventoryTransactionsMutation, useGetAllInventoryTransactionsMutation, useSearchInventoryTransactionsMutation } from "../../redux-toolkit/services/inventoryTransactionsService";
import { getInventoryTransactionsDetails, getInventoryTransactionsSearch, getInventoryTransactionsTotalRecords, setInventoryTransactions, setInventoryTransactionsBySearch } from "../../redux-toolkit/slices/inventoryTransactionsSlice";
import InventoryReportData from "./InventoryReportData";
import { useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";

type Props = {};
const InventoryReports = (props: Props) => {

    const params = useParams();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;
    const dispatch = useDispatch();

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");


    //getMutations
    const [getAllInventoryCategoryMasterWithPagination, getAllInventoryCategoryMasterWithPaginationResponse] = useGetAllInventoryCategoryMasterMutation();
    const [getAllInventoryItemMasterWithPagination, getAllInventoryItemMasterWithPaginationResponse] = useGetAllInventoryItemMasterMutation();
    const [getAllInventoryOpeningBalanceWithPagination, getAllInventoryOpeningBalanceWithPaginationResponse] = useGetAllInventoryOpeningBalanceMutation();
    const [getAllInventoryTransactionsWithPagination, getAllInventoryTransactionsWithPaginationResponse] = useGetAllInventoryTransactionsMutation();

    //get by search
    const [getInventoryCategoryMastersBySearch, getInventoryCategoryMastersBySearchResponse] = useSearchInventoryCategoryMasterMutation();
    const [getInventoryItemMastersBySearch, getInventoryItemMastersBySearchResponse] = useSearchInventoryItemMasterMutation();
    const [getInventoryOpeningBalanceBySearch, getInventoryOpeningBalanceBySearchResponse] = useSearchInventoryOpeningBalanceMutation();
    const [getInventoryTransactionsBySearch, getInventoryTransactionsBySearchResponse] = useSearchInventoryTransactionsMutation();

    //delete mutation  
    const [deleteInventoryCategoryMaster, deleteInventoryCategoryMasterResponse] = useDeleteInventoryCategoryMasterMutation()
    const [deleteInventoryItemMaster, deleteInventoryItemMasterResponse] = useDeleteInventoryItemMasterMutation()
    const [deleteInventoryOpeningBalance, deleteInventoryOpeningBalanceResponse] = useDeleteInventoryOpeningBalanceMutation();
    const [deleteInventoryTransactions, deleteInventoryTransactionsResponse] = useDeleteInventoryTransactionsMutation();

    //save
    const [logAudit] = useSaveAuditLogMutation();


    //totalRecords
    const totalInventoryCategoryMaster: any = useAppSelector(getInventoryCategoryMasterTotalRecords)
    const totalInventoryItemMaster: any = useAppSelector(getInventoryItemMasterTotalRecords)
    const totalInventoryOpeningBalance: any = useAppSelector(getInventoryOpeningBalanceTotalRecords)
    const totalInventoryTransactions: any = useAppSelector(getInventoryTransactionsTotalRecords)

    //selector
    const inventoryCategoryMasterSearchData: any = useAppSelector(getInventoryCategoryMasterSearch);
    const inventoryCategoryMasterDetailsData: any = useAppSelector(getInventoryCategoryMasterDetails);
    const inventoryItemSearchData: any = useAppSelector(getInventoryItemMasterDetails);
    const inventoryItemMasterData: any = useAppSelector(getInventoryItemMasterSearch);
    const inventoryOpeningBalanceSearchData: any = useAppSelector(getInventoryOpeningBalanceSearch);
    const inventoryOpeningBalanceData: any = useAppSelector(getInventoryOpeningBalanceDetails);
    const inventoryTransactionsSearchData: any = useAppSelector(getInventoryTransactionsSearch);
    const inventoryTransactionsData: any = useAppSelector(getInventoryTransactionsDetails);


    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.INVENTORY_CATEGORY_MASTER_PATH:
                setReportName(REPORT_NAME.INVENTORY_CATEGORY_MASTER)
                break;
            case REPORT_PATH.INVENTORY_ITEM_MASTER_PATH:
                setReportName(REPORT_NAME.INVENTORY_ITEM_MASTER)
                break;
            case REPORT_PATH.INVENTORY_OPENING_BALANCE_PATH:
                setReportName(REPORT_NAME.INVENTORY_OPENING_BALANCE)
                break;
            case REPORT_PATH.INVENTORY_TRANSACTIONS_PATH:
                setReportName(REPORT_NAME.INVENTORY_TRANSACTIONS)
                break;

            default:
        }
    }, [params.reportType]);



    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER && INVENTORY_CATEGORY_MASTER_COLUMN) {
            INVENTORY_CATEGORY_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.INVENTORY_ITEM_MASTER && INVENTORY_ITEM_MASTER_COLUMN) {
            INVENTORY_ITEM_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE && INVENTORY_OPENING_BALANCE_COLUMN) {
            INVENTORY_OPENING_BALANCE_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.INVENTORY_TRANSACTIONS && INVENTORY_TRANSACTIONS_COLUMN) {
            INVENTORY_TRANSACTIONS_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER) {
            getAllInventoryCategoryMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        } else if (reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {
            getAllInventoryItemMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
        else if (reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {
            getAllInventoryOpeningBalanceWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
        else if (reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {
            getAllInventoryTransactionsWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }

    }, [reportName]);


    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER) {
                getAllInventoryCategoryMasterWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            } else if (reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {
                getAllInventoryItemMasterWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            } else if (reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {
                getAllInventoryTransactionsWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            } else if (reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {
                getAllInventoryOpeningBalanceWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            }

            setCall("N");
        }
    }, [call]);


    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER) {
            getAllInventoryCategoryMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {
            getAllInventoryItemMasterWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }
        else if (reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {
            getAllInventoryOpeningBalanceWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }
        else if (reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {
            getAllInventoryTransactionsWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }

        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER) {
            deleteInventoryCategoryMaster({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.INVENTORY_CATEGORY_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

        } else if (reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {
            deleteInventoryItemMaster({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.INVENTORY_ITEM_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
        } else if (reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {


            deleteInventoryTransactions({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.INVENTORY_TRANSACTIONS,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            }

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
        } else if (reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {
            deleteInventoryOpeningBalance({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.INVENTORY_OPENING_BALANCE,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            }

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
        }
    };


    useEffect(() => {
        if (deleteInventoryCategoryMasterResponse.isSuccess) {
            if (deleteInventoryCategoryMasterResponse.data?.isActive) {
                alertMessage("Inventory Category Master enabled successfully", "success");
            } else {
                alertMessage("Inventory Category Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteInventoryCategoryMasterResponse.isError) {
            alertMessage("Error while deleting Inventory Category Master", "error");
        }
    }, [
        deleteInventoryCategoryMasterResponse.isSuccess,
        deleteInventoryCategoryMasterResponse.isError,
    ]);

    useEffect(() => {
        if (deleteInventoryOpeningBalanceResponse.isSuccess) {
            if (deleteInventoryOpeningBalanceResponse.data?.isActive) {
                alertMessage("Inventory Opening Balance enabled successfully", "success");
            } else {
                alertMessage("Inventory Opening Balance deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteInventoryOpeningBalanceResponse.isError) {
            alertMessage("Error while deleting Inventory Opening Balance", "error");
        }
    }, [
        deleteInventoryOpeningBalanceResponse.isSuccess,
        deleteInventoryOpeningBalanceResponse.isError,
    ]);

    useEffect(() => {
        if (deleteInventoryTransactionsResponse.isSuccess) {
            if (deleteInventoryTransactionsResponse.data?.isActive) {
                alertMessage("Inventory Transactions enabled successfully", "success");
            } else {
                alertMessage("Inventory Transactions deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteInventoryTransactionsResponse.isError) {
            alertMessage("Error while deleting Inventory Transactions", "error");
        }
    }, [
        deleteInventoryTransactionsResponse.isSuccess,
        deleteInventoryTransactionsResponse.isError,
    ]);

    useEffect(() => {
        if (deleteInventoryItemMasterResponse.isSuccess) {
            if (deleteInventoryItemMasterResponse.data?.isActive) {
                alertMessage("Inventory Item Master enabled successfully", "success");
            } else {
                alertMessage("Inventory Item Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteInventoryItemMasterResponse.isError) {
            alertMessage("Error while deleting Inventory Item Master", "error");
        }
    }, [
        deleteInventoryItemMasterResponse.isSuccess,
        deleteInventoryItemMasterResponse.isError,
    ]);



    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    const handleSearch = (event: any) => {
        if (reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER) {
            getInventoryCategoryMastersBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {
            getInventoryItemMastersBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
        else if (reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {
            getInventoryTransactionsBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
        else if (reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {
            getInventoryOpeningBalanceBySearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
    };

    useEffect(() => {
        if (getInventoryItemMastersBySearchResponse.isSuccess) {
            dispatch(setInventoryItemMasterBySearch(getInventoryItemMastersBySearchResponse));
        } else if (getInventoryItemMastersBySearchResponse.isError) {
            let response: any = getInventoryItemMastersBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getInventoryItemMastersBySearchResponse.isSuccess, getInventoryItemMastersBySearchResponse.isError]);

    useEffect(() => {
        if (getInventoryCategoryMastersBySearchResponse.isSuccess) {
            dispatch(setInventoryCategoryMasterBySearch(getInventoryCategoryMastersBySearchResponse));
        } else if (getInventoryCategoryMastersBySearchResponse.isError) {
            let response: any = getInventoryCategoryMastersBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [getInventoryCategoryMastersBySearchResponse.isSuccess, getInventoryCategoryMastersBySearchResponse.isError]);


    useEffect(() => {
        if (getAllInventoryCategoryMasterWithPaginationResponse.isSuccess) {
            dispatch(setInventoryCategoryMaster(getAllInventoryCategoryMasterWithPaginationResponse));
        } else if (getAllInventoryCategoryMasterWithPaginationResponse.isError) {
            let response: any = getAllInventoryCategoryMasterWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllInventoryCategoryMasterWithPaginationResponse.isSuccess, getAllInventoryCategoryMasterWithPaginationResponse.isError]);

    useEffect(() => {
        if (getAllInventoryItemMasterWithPaginationResponse.isSuccess) {
            dispatch(setInventoryItemMaster(getAllInventoryItemMasterWithPaginationResponse));
        } else if (getAllInventoryItemMasterWithPaginationResponse.isError) {
            let response: any = getAllInventoryItemMasterWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllInventoryItemMasterWithPaginationResponse.isSuccess, getAllInventoryItemMasterWithPaginationResponse.isError]);


    useEffect(() => {
        if (getAllInventoryOpeningBalanceWithPaginationResponse.isSuccess) {
            dispatch(setInventoryOpeningBalance(getAllInventoryOpeningBalanceWithPaginationResponse));
        } else if (getAllInventoryOpeningBalanceWithPaginationResponse.isError) {
            let response: any = getAllInventoryOpeningBalanceWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [
        getAllInventoryOpeningBalanceWithPaginationResponse.isSuccess,
        getAllInventoryOpeningBalanceWithPaginationResponse.isError
    ]);

    useEffect(() => {
        if (getAllInventoryTransactionsWithPaginationResponse.isSuccess) {
            dispatch(setInventoryTransactions(getAllInventoryTransactionsWithPaginationResponse));
        } else if (getAllInventoryTransactionsWithPaginationResponse.isError) {
            let response: any = getAllInventoryTransactionsWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [
        getAllInventoryTransactionsWithPaginationResponse.isSuccess,
        getAllInventoryTransactionsWithPaginationResponse.isError
    ]);


    useEffect(() => {
        if (getInventoryTransactionsBySearchResponse.isSuccess) {
            dispatch(setInventoryTransactionsBySearch(getInventoryTransactionsBySearchResponse));
        } else if (getInventoryTransactionsBySearchResponse.isError) {
            let response: any = getInventoryTransactionsBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [
        getInventoryTransactionsBySearchResponse.isSuccess,
        getInventoryTransactionsBySearchResponse.isError
    ]);

    useEffect(() => {
        if (getInventoryOpeningBalanceBySearchResponse.isSuccess) {
            dispatch(setInventoryOpeningBalanceBySearch(getInventoryOpeningBalanceBySearchResponse));
        } else if (getInventoryOpeningBalanceBySearchResponse.isError) {
            let response: any = getInventoryOpeningBalanceBySearchResponse.error;
            alertMessage(response, "error");
        }
    }, [
        getInventoryOpeningBalanceBySearchResponse.isSuccess,
        getInventoryOpeningBalanceBySearchResponse.isError
    ]);


    useEffect(() => {
        if (inventoryCategoryMasterSearchData && reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER) {
            setDatasource(inventoryCategoryMasterSearchData);
        }
    }, [inventoryCategoryMasterSearchData]);

    useEffect(() => {
        if (inventoryItemSearchData && reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {
            setDatasource(inventoryItemSearchData);
        }
    }, [inventoryItemSearchData]);


    useEffect(() => {
        if (inventoryTransactionsSearchData && reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {
            setDatasource(inventoryTransactionsSearchData);
        }
    }, [inventoryTransactionsSearchData]);

    useEffect(() => {
        if (inventoryOpeningBalanceData && reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {
            setDatasource(inventoryOpeningBalanceData);
        }
    }, [inventoryOpeningBalanceData]);



    useEffect(() => {
        if (inventoryItemMasterData && reportName === REPORT_NAME.INVENTORY_ITEM_MASTER) {
            setDatasource(inventoryItemMasterData);
        }
    }, [inventoryItemMasterData]);


    useEffect(() => {
        if (inventoryCategoryMasterDetailsData && reportName === REPORT_NAME.INVENTORY_CATEGORY_MASTER) {
            setDatasource(inventoryCategoryMasterDetailsData);
        }
    }, [inventoryCategoryMasterDetailsData]);


    useEffect(() => {
        if (inventoryOpeningBalanceSearchData && reportName === REPORT_NAME.INVENTORY_OPENING_BALANCE) {
            setDatasource(inventoryOpeningBalanceSearchData);
        }
    }, [inventoryOpeningBalanceSearchData]);


    useEffect(() => {
        if (inventoryTransactionsData && reportName === REPORT_NAME.INVENTORY_TRANSACTIONS) {
            setDatasource(inventoryTransactionsData);
        }
    }, [inventoryTransactionsData]);


    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                           { reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    {/* <img src={gear} alt="" /> */}
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div onClick={handleShow} className="d-flex px-2 align-items-center mt-1">
                        <Button
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                        // onClick={() => {
                        //     setActionType(ACTION_TYPE.ADD_ACTION);
                        // }}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {
                        getAllInventoryCategoryMasterWithPaginationResponse.isLoading ||
                            getAllInventoryItemMasterWithPaginationResponse.isLoading ||
                            getAllInventoryOpeningBalanceWithPaginationResponse.isLoading ||
                            getAllInventoryTransactionsWithPaginationResponse.isLoading ||

                            getInventoryCategoryMastersBySearchResponse.isLoading ||
                            getInventoryItemMastersBySearchResponse.isLoading ||
                            getInventoryOpeningBalanceBySearchResponse.isLoading ||
                            getInventoryTransactionsBySearchResponse.isLoading ||

                            deleteInventoryCategoryMasterResponse.isLoading ||
                            deleteInventoryItemMasterResponse.isLoading ||
                            deleteInventoryOpeningBalanceResponse.isLoading ||
                            deleteInventoryTransactionsResponse.isLoading ? (

                            <Loading />
                        ) : (
                            ""
                        )
                    }

                    {show && (
                        <InventoryReportData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                        />
                    )}
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.INVENTORY_CATEGORY_MASTER:
                                    return totalInventoryCategoryMaster;
                                case REPORT_NAME.INVENTORY_ITEM_MASTER:
                                    return totalInventoryItemMaster;
                                case REPORT_NAME.INVENTORY_OPENING_BALANCE:
                                    return totalInventoryOpeningBalance;
                                case REPORT_NAME.INVENTORY_TRANSACTIONS:
                                    return totalInventoryTransactions;
                                default:
                                    return [];
                            }
                        })(),
                        // hideOnSinglePage: true,  
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};
export default InventoryReports;